import React from 'react';
import moment from 'moment';
import { Document } from '@react-pdf/renderer';

import TitlePage from './TitlePage';
import EVPage from './Page';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';
import Page6 from './Page6';
import Page7 from './Page7';

const MAX_CHAT_MESSAGES = 100;
const MAX_FORUM_POSTS = 100;

function PDFReportDocument(props) {
  const {
    event,
    currentUser,
    onRender,
    totalUsers,
    totalConcurrences,
    charts,
    countryDescription,
    countries,
    hoursDescription,
    chats,
    forums,
  } = props;

  // Format date for footer
  const generatedDate = moment().format(
    'dddd DD [de] MMMM [de] YYYY [a las] HH:mm [hrs]'
  );

  const { displayName, email } = currentUser;
  const { firstCountry, firstCity, secondCountries } = countryDescription || {};
  const { maxHour, maxConcurrence } = hoursDescription || {};

  // Limit chat and forum data
  const displayChats = chats?.slice(0, MAX_CHAT_MESSAGES) || [];
  const displayForums = forums?.slice(0, MAX_FORUM_POSTS) || [];

  return (
    <Document
      onRender={onRender}
      title={`Informe de Audiencia - ${event.name}`}
      author={displayName}
      creator="EventoVirtual.co"
      producer="EventoVirtual PDF Generator"
    >
      {/* Title Page */}
      <TitlePage
        name={event.name}
        startDate={event.startDate?.format?.('DD [de] MMMM, YYYY') || ''}
        userName={displayName}
      />

      {/* Content Pages */}
      <EVPage date={generatedDate} user={displayName} email={email} noWrap>
        {/* Page 2: KPIs and Cities Chart */}
        <Page2
          totalConcurrences={totalConcurrences}
          totalUsers={totalUsers}
          c1={charts?.c1}
        />

        {/* Page 3: Countries Chart and Timeline */}
        <Page3
          c2={charts?.c2}
          firstCountry={firstCountry}
          firstCity={firstCity}
          secondCountries={secondCountries}
          c3={charts?.c3}
          maxHour={maxHour}
          maxConcurrence={maxConcurrence}
        />

        {/* Page 4: World Map and Countries Table */}
        <Page4 c4={charts?.c4} countries={countries} />

        {/* Page 5: Browser and OS Distribution */}
        <Page5 c7={charts?.c7} c8={charts?.c8} />

        {/* Page 6: Chat Messages (if available) */}
        {displayChats.length > 0 && <Page6 chats={displayChats} />}

        {/* Page 7: Forum Q&A (if available) */}
        {displayForums.length > 0 && <Page7 forums={displayForums} />}
      </EVPage>
    </Document>
  );
}

export default PDFReportDocument;
